import AlertEdit from "./AlertEdit";
import React from "react";
import Search from "./Search";

export default function EditStock({
  formBuyingValidation,
  buyDateEdit,
  buyPriceEdit,
  buyQuantityEdit,
  editStockId,
  handleEditedStock,
  setSearchInput,
  searchInput,
  buyNumber,
}) {
  const formEditingValidation = () => {
    if (document.getElementById("editingModalSuccess")) {
      document.getElementById("editingModalSuccess").classList.add("d-none");
    }
    if (buyDateEdit.current.value === "") {
      document.getElementById("nodateEdit").classList.remove("d-none");
      document
        .getElementById("nodateInputEdit")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("nodateEdit").classList.add("d-none");
      document
        .getElementById("nodateInputEdit")
        .classList.remove("border", "border-danger");
    }
    if (document.querySelectorAll("#dropdownMenu")[0].value === "") {
      document.querySelectorAll("#nonumber")[0].classList.remove("d-none");
      document
        .querySelectorAll("#dropdownMenu")[0]
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.querySelectorAll("#nonumber")[0].classList.add("d-none");
      document
        .querySelectorAll("#dropdownMenu")[0]
        .classList.remove("border", "border-danger");
    }
    if (buyQuantityEdit.current.value === "") {
      document.getElementById("noqntyEdit").classList.remove("d-none");
      document
        .getElementById("buyQntyInputEdit")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("noqntyEdit").classList.add("d-none");
      document
        .getElementById("buyQntyInputEdit")
        .classList.remove("border", "border-danger");
    }
    if (buyPriceEdit.current.value === "") {
      document.getElementById("nopriceEdit").classList.remove("d-none");
      document
        .getElementById("buypriceInputEdit")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("nopriceEdit").classList.add("d-none");
      document
        .getElementById("buypriceInputEdit")
        .classList.remove("border", "border-danger");
    }
  };
  return (
    <>
      <div
        className="modal fade text-right"
        id="editStock"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-dark" id="exampleModalLabel">
                تعديل
              </h5>
              <button
                type="button"
                className="close ml-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <AlertEdit />
            <div className="modal-body">
              <form className="needs-validation">
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <input
                      type="hidden"
                      className="form-control"
                      ref={editStockId}
                    ></input>
                    <label htmlFor="validationCustom01" className="text-dark">
                      تاريخ الشراء
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="nodateInputEdit"
                      ref={buyDateEdit}
                      onChange={formEditingValidation}
                    ></input>
                    <small className="text-danger d-none" id="nodateEdit">
                      يرجى اضافة التاريخ
                    </small>
                  </div>
                  <div className="form-group col-md-12">
                    <label htmlFor="inputPassword3" className="text-dark">
                      الشركة
                    </label>
                    <Search
                      formEditingValidation={formEditingValidation}
                      formBuyingValidation={formBuyingValidation}
                      setSearchInput={setSearchInput}
                      searchInput={searchInput}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="inputPassword3" className="text-dark">
                      عدد الاسهم
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="buyQntyInputEdit"
                      ref={buyQuantityEdit}
                      onChange={formEditingValidation}
                    ></input>
                    <small id="noqntyEdit" className="text-danger d-none">
                      يرجى اضافة عدد الاسهم
                    </small>
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="inputPassword3" className="text-dark">
                      سعر الشراء
                    </label>
                    <input
                      ref={buyPriceEdit}
                      onChange={formEditingValidation}
                      type="number"
                      step=".01"
                      className="form-control"
                      id="buypriceInputEdit"
                    ></input>
                    <small id="nopriceEdit" className="text-danger d-none">
                      يرجى اضافة سعر الشراء
                    </small>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() =>
                  handleEditedStock(
                    editStockId.current.value,
                    formEditingValidation
                  )
                }
                // data-dismiss="modal"
              >
                حفظ
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
